import { faFilter } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import type { ReactElement, ReactNode } from 'react'
import {
  filterableCellAction,
  filterableCellActionCentered,
  filterableCellContent,
  filterableCellContentCentered,
  filterableCellWrapper,
  filterableCellWrapperCentered
} from './DataTable.css'

type DataTableFilterableCellProps = {
  children: ReactNode
  filterValue: string
  onFilter: (value: string) => void
  filterTitle?: string
  center?: boolean
}

export const DataTableFilterableCell = ({
  children,
  filterValue,
  onFilter,
  filterTitle = 'Filtrer sur cette valeur',
  center = false
}: DataTableFilterableCellProps): ReactElement => (
  <div
    className={clsx(
      filterableCellWrapper,
      center && filterableCellWrapperCentered
    )}
  >
    <span
      className={clsx(
        filterableCellContent,
        center && filterableCellContentCentered
      )}
    >
      {children}
    </span>
    <button
      type="button"
      className={clsx(
        filterableCellAction,
        center && filterableCellActionCentered
      )}
      aria-label={filterTitle}
      onClick={(e) => {
        e.stopPropagation()
        onFilter(filterValue)
      }}
      title={filterTitle}
    >
      <FontAwesomeIcon icon={faFilter} />
    </button>
  </div>
)
